var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pr-wrapper',{directives:[{name:"nv",rawName:"v-nv:scope",value:('standby'),expression:"'standby'",arg:"scope"}],attrs:{"fs":"","bg":"darken","nv-exit-protect":""}},[_c('div',{directives:[{name:"nv",rawName:"v-nv"}],staticClass:"standby"})])
}
var staticRenderFns = []

export { render, staticRenderFns }